import * as React from "react"
import { CustomTable } from "@/components/Tables/CustomTable"
import { columns } from "./Columns"
import { useCustomQuery } from "@/hooks/useCustomQuery"
import { CrudProvider, useCrudContext } from "@/context/crudContext"
import DataTable from "@/components/Tables/DataTable"
import { useEffect, useState } from "react"
import StockAuditDetailPage from "./StockAuditDetail"
import { useNavigate } from "react-router-dom"
import { apiFetch } from "@/hooks/apiFetch"

const ACTIVE_AUDIT_STATUSES = ["pending", "processing"]

const stockAuditRefetchInterval = (query) => {
  const audits = query.state.data?.data?.data ?? []

  return audits.some((audit) => ACTIVE_AUDIT_STATUSES.includes(audit.status))
    ? 3000
    : false
}

export default function StockAuditList() {
  return (
    <>
      <CrudProvider>
        <StockAuditTable />
      </CrudProvider>
    </>
  )
}

function StockAuditTable() {
  const navigate = useNavigate()

  const handleOnView = (row) => {
    navigate(`/pos/stock-audit/${row.id}`)
  }

  const handleOnImport = async (data) => {
    const formData = new FormData()
    formData.append("file", data.file, data.file.name)

    return apiFetch("stock-audit", {
      method: "POST",
      body: formData,
    })
  }

  return (
    <>
      <CustomTable
        columns={columns}
        apiPath="stock-audit"
        action
        view
        showEdit={false}
        showDelete={false}
        onView={handleOnView}
        addBtn={false}
        label="Stock Audits"
        showImport={true}
        onImport={handleOnImport}
        refetchInterval={stockAuditRefetchInterval}
      />
    </>
  )
}
